import axiosClient2 from "./axiosClient2";
import axiosClientKB2 from "./axiosClientKB2";
import axios from "axios";


export const getKBInsight = (body) => {
    return axiosClient2.post("/Dev_Api/api/fetch_agent_response", body);
};
export const getKBInsightAnswer = (body) => {
    return axiosClientKB2.post("/default/bedrock-agent-function", body);
};

export const getPdfUrl = async (pdfpath) => {
    // return axiosClient2.post("/api/get_pdf_url");
    try {
        const response = await axios.get(`'http://127.0.0.1:5000/api/get_pdf_url?s3Uri=${pdfpath}`);
        return response
    } catch (error) {
        console.error('Error fetching data:', error.message);
        // Handle errors (e.g., server errors, network errors, etc.)
    }
};
